import { Memo } from 'models/Memo';
import { patchMemo } from 'networking/mindfeed/services/memo.service';
import { useOptimisticMemoMutation } from './useOptimisticMemoMutation';

type Variables = {
  memo: Memo;
  updates: Partial<Memo>;
};

export const usePatchMemo = ({
  onSuccess,
}: {
  onSuccess?: (data: Memo) => void;
} = {}) =>
  useOptimisticMemoMutation<Memo, Variables>({
    mutationFn: ({ memo, updates }) => patchMemo(memo, updates),
    optimistic: (cache, { memo, updates }) => {
      if (cache.contains(memo.id)) cache.update(memo.id, updates);
    },
    onSuccess: (memo, _variables, { cache }) => {
      // Swap the optimistic memo for the server's authoritative version.
      cache.replace(memo);
      onSuccess?.(memo);
    },
  });
